<template>
  <div class="max-w-full grow">
    <div v-if="booking">
      <h2 class="mb-4">
        {{ t('handoverOverview') }}
      </h2>
      <HandoverOverviewForm :booking="booking" @on-submit="handleSubmit" />
    </div>
    <div v-else class="flex justify-center">
      <Spinner />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useBooking } from '@/queries/use-bookings';
import { useRoute } from 'vue-router';
import HandoverOverviewForm from './HandoverOverviewForm.vue';
import Spinner from '@/components/icons/Spinner.vue';
import { useProcessNavigation } from '@/hooks/use-process-step-tracking';

const { t } = useI18n();
const route = useRoute();
const { goToNext } = useProcessNavigation();

const { data: booking } = useBooking(route.params.id as string, true, { handoverAdjustment: true });

const handleSubmit = async () => {
  goToNext();
};
</script>

<i18n lang="json">
{
  "en": {
    "handoverOverview": "Handover overview"
  },
  "de": {
    "handoverOverview": "Übergabeübersicht"
  },
  "es": {
    "handoverOverview": "Vista general de la entrega"
  }
}
</i18n>
